import React from 'react'
import { usePageFlow } from '@hooks/usePageFlow'
import { ProgressBar } from '@components/ui-css/ProgressBar'
import { IconButtonLink } from '@components/ui-css/IconButton'
import styles from './styles/DrawerTopHeader.module.scss'

type DrawerTopHeaderProps = {
  activeStep: number
  hideNavigateBack?: boolean
  onNavigateBack?: () => void
}

export const DrawerTopHeader: React.FC<DrawerTopHeaderProps> = props => {
  const { activeStep, hideNavigateBack = true, onNavigateBack } = props
  const { showSteps, maxSteps } = usePageFlow()
  const showProgress = showSteps && activeStep > 0

  return (
    <div className={styles.container}>
      {showProgress && <ProgressBar maxSteps={maxSteps} step={activeStep} className={styles.progressNoNav} />}

      <div className={styles.progressWithNav}>
        {!hideNavigateBack && (
          <IconButtonLink
            className={styles.backButton}
            iconProps={{ name: 'arrow-left' }}
            onClick={() => onNavigateBack?.()}
          />
        )}
        {showProgress && <ProgressBar maxSteps={maxSteps} step={activeStep} className={styles.progressBar} />}
      </div>
    </div>
  )
}
